import { getRequest, postRequest, putRequest} from "../utils/axiosHandler";
import { toast } from "react-toastify";
import { AuthContext } from "../contexts/AuthContext";
import { useContext } from "react";

// fucntion to get categories
export const getCategories = async () => {
  try {
    return await getRequest('/public/category');
  } catch (error) {
    throw error;
  }
};

export const getSubCategories = async (id) => {
  try {
    return await getRequest(`/public/category/sub?id=${id}`);
  } catch (error) {
    throw error;
  }
}

export const searchProducts = async (query = '', page = 0, size = 20) => {
    try {
      return await getRequest(`/public/products?name=${query}&page=${page}&size=${size}`);
    } catch (error) {
      throw error;
    }
  };
  export const searchProductsSuggestions = async (query = '', page = 0, size = 6) => {
    try {
      return await getRequest(`/public/products/suggestions?name=${query}&page=${page}&size=${size}`);
    } catch (error) {
      throw error;
    }
  };

export const getAllProductsById = async (id) => {
    try {
        return await getRequest(`/public/products/${id}`);
    } catch (error) {
        throw error;
    }
    }
export const getProductById = async (id) => {
      try {
          return await getRequest(`/public/products/single/${id}`);
      } catch (error) {
          throw error;
      }
      }
export const getProductsByCategory = async (id, page = 0, size = 20) => {
    try {
        return await getRequest(`/public/products/category/${id}?page=${page}&size=${size}`);
    } catch (error) {
        throw error;
    }
    }

export const getProductVariations = async (id,payload) => {
    try {
      //console.log("payload",payload);
        return await postRequest(`/public/products/${id}/variation`,payload);
        
    } catch (error) {
        throw error;
    }
    }    

// export const getProductsByAccountId = async (id, page = 0, size = 20) => {
//     try {
//         return await getRequest(`/public/products/account/${id}?page=${page}&size=${size}`);
//     } catch (error) {
//         throw error;
//     }
//     }

export const getProductsByAccountId = async (id, page = 0, size = 20, sort = "", search = "") => {
  try {
    let queryParams = `?page=${page}&size=${size}`;
    if (sort) queryParams += `&sort=${sort}`;
    if (search) queryParams += `&search=${encodeURIComponent(search)}`;
    return await getRequest(`/public/products/account/${id}${queryParams}`);
  } catch (error) {
    throw error;
  }
};


//save cart for now in local storage

// export const addToCart = (product) => {
//   let cart = JSON.parse(localStorage.getItem('cart')) || [];
//   const existingProduct = cart.find(p => p.id === product.productid);
//   console.log(product.productid);
  
//   if (existingProduct) {
//     if (existingProduct.quantity + product.quantity<= (product.stockQuantity || 0)) {
//       existingProduct.quantity += product.quantity;
//       // alert('Product added to cart');
//       toast.success('Product added to cart');
//     } else {
//       // alert(`You can only add up to ${product.stockQuantity} of this item.`);
//       toast.info(`You can only add up to ${product.stockQuantity} of this item.`);
//       return;  // Stop execution if the limit is reached
//     }
//   } else {
//     cart.push({ ...product, quantity: product.quantity });
//     // alert('Product added to cart');
//     toast.success('Product added to cart');
//   }

//   // Update localStorage after changes
//   localStorage.setItem('cart', JSON.stringify(cart));
// };


// export const addToCart = async (products) => {
//   try {
//     // Fetch latest stock quantity from API
//     const response = await getRequest(`/public/products/${products.id}`);
//     console.log("Add to cart response", response);
//     const latestStock = response?.product?.stockQuantity ?? 0; // Get stock, default to 0 if undefined

//     let cart = JSON.parse(localStorage.getItem('cart')) || [];
//     const existingProduct = cart.find(p => p.id === products.id);

//     console.log(`Product ID: ${products.id}, Latest Stock: ${latestStock}`);

//     if (!products.id || !products.quantity) {
//       toast.error('Invalid product data.');
//       return;
//     }

//     if (existingProduct) {
//       if (existingProduct.quantity + products.quantity <= latestStock) {
//         existingProduct.quantity += products.quantity;
//         toast.success('Product quantity updated in cart.');
//       } else {
//         toast.info(`Only ${latestStock} items available.`);
//         return; // Stop execution if limit is reached
//       }
//     } else {
//       if (products.quantity > latestStock) {
//         toast.info(`Only ${latestStock} items available.`);
//         return;
//       }
//       cart.push({ id: products.id, quantity: products.quantity });
//       toast.success('Product added to cart.');
//     }

//     // Update localStorage after changes
//     localStorage.setItem('cart', JSON.stringify(cart));

//   } catch (error) {
//     console.error('Error fetching stock quantity:', error);
//     toast.error('Failed to fetch stock data. Please try again.');
//   }
// };

export const addToCart = async (products) => {
  try {
    // Fetch latest stock quantity from API (but don't restrict cart updates)
    const response = await getRequest(`/public/products/${products.id}`);
    //console.log("Add to cart response", response);
    
    let cart = JSON.parse(localStorage.getItem("cart")) || [];
    const existingProduct = cart.find((p) => p.id === products.id);

    //console.log(`Product ID: ${products.id}`);

    // Validate product data
    if (!products.id || !products.quantity) {
      toast.error("Invalid product data.");
      return;
    }

    // Update quantity if product exists, otherwise add it to cart
    if (existingProduct) {
      existingProduct.quantity += products.quantity;
      toast.success("Product quantity updated in cart.");
    } else {
      cart.push({ id: products.id, quantity: products.quantity });
      toast.success("Product added to cart.");
    }

    // Update localStorage after changes
    localStorage.setItem("cart", JSON.stringify(cart));

  } catch (error) {
    console.error("Error fetching stock quantity:", error);
    toast.error("Failed to fetch stock data. Please try again.");
  }
};



export const removeItemFromCart = (id) => {
  let cart = JSON.parse(localStorage.getItem('cart')) || [];
  cart = cart.filter(p => p.id !== id);
  localStorage.setItem('cart', JSON.stringify(cart));
  // alert('Product removed from cart');
  //toast.success('Product removed from cart');
}

export const getCart = () => {
  return JSON.parse(localStorage.getItem('cart')) || [];
}

export const clearCart = () => {
  localStorage.removeItem('cart');
  // alert('Cart cleared');
  //toast.info('Cart cleared');
}
export const getCartCount = () => {
  let cart = JSON.parse(localStorage.getItem('cart')) || [];
  return cart.length; 
}
export const clearCartAfterCheckoutRequest = () => {
  localStorage.removeItem('cart');
}

export const clearCartOnLogin = () => {
  localStorage.removeItem('cart');
  // alert('Cart cleared');
  //toast.info('Cart cleared');
}


export const saveGusetCustomerOrder = async (order) => {
  try {
    return await postRequest('/public/orders', order);
  } catch (error) {
    throw error;
  }
}

export const getPriceRange = async () => {
  try {
    return await getRequest('/public/products/priceRange');
  } catch (error) {
    throw error;
  }
}


export const fetchFilteredProducts = async (
  page = 0, 
  size = 18, 
  minPrice, 
  maxPrice, 
  categoryIds = [], // Accept array of category IDs
  sortOption = "newArrivals"  // Default sort option
) => {
  try {
    let url = `/public/products/filter?page=${page}&size=${size}&minPrice=${minPrice}&maxPrice=${maxPrice}&sortOption=${sortOption}`;

    if (categoryIds.length > 0) {
      const categoryQuery = categoryIds.map(id => `productCategoryIds=${id}`).join("&");
      url += `&${categoryQuery}`;
    }

    return await getRequest(url);
  } catch (error) {
    throw error;
  }
};



// only for guest user now. store product in session storage

export const handleBuyNow = async (product) => { // Add quantity: 1
  sessionStorage.setItem("buyNow", JSON.stringify(product));
  
}

export const getBuyNow = () => {
  return JSON.parse(sessionStorage.getItem('buyNow'));
}

export const clearBuyNow = () => {
  sessionStorage.removeItem('buyNow');
}

// export const getBuyNowTotal = () => {
//   const buyNowProduct = JSON.parse(sessionStorage.getItem("buyNow"));
//   console.log("Buy Now Product:", buyNowProduct);

//   if (!buyNowProduct) return 0; // If no Buy Now item exists, return 0

//   const price = buyNowProduct.salePrice || buyNowProduct.regularPrice || 0; // Use salePrice if available, otherwise regularPrice
//   const quantity = buyNowProduct.quantity || 1; // Default quantity to 1 if not set

//   return price * quantity;
// };
// export const getBuyNowTotal = () => {
//   const buyNowProduct = JSON.parse(sessionStorage.getItem("buyNow"));
//   console.log("Buy Now Product:", buyNowProduct);
//   if (!buyNowProduct) return 0; // If no Buy Now item exists, return 0

//   const quantity = buyNowProduct.quantity || 1;
//   let effectiveUnitPrice = 0;

//   // Check if the configuration has an active discount
//   const config = buyNowProduct.configuration;
//   const discountActive =
//     config &&
//     config.collectionConfiguration &&
//     config.collectionConfiguration.discount &&
//     config.configStatus === "active";

//   if (discountActive) {
//     const discount = config.collectionConfiguration.discount;
//     // Calculate the sale price using the regular price and the discount.
//     // This applies whether a salePrice was initially present or not.
//     effectiveUnitPrice = buyNowProduct.regularPrice - (buyNowProduct.regularPrice * discount) / 100;
//   } else {
//     // If there's no active discount, use the salePrice if available, otherwise the regularPrice.
//     effectiveUnitPrice = buyNowProduct.salePrice || buyNowProduct.regularPrice || 0;
//   }

//   return effectiveUnitPrice * quantity;
// };

export const getBuyNowTotal = () => {
  const buyNowProduct = JSON.parse(sessionStorage.getItem("buyNow"));
 // console.log("Buy Now Product:", buyNowProduct);
  if (!buyNowProduct) return 0; // If no Buy Now item exists, return 0

  const quantity = buyNowProduct.quantity || 1;
  let effectiveUnitPrice = 0;

  // Check if the configuration has an active discount
  const config = buyNowProduct.configuration;
  const discountActive =
    config &&
    config?.Sale?.collectionConfiguration &&
    config?.Sale?.collectionConfiguration?.discount &&
    config.Sale?.configStatus === "active";

  if (discountActive) {
    const discount = config.Sale.collectionConfiguration.discount;
    // If a salePrice exists, apply the discount on it; otherwise, use the regularPrice.
    if (buyNowProduct.salePrice) {
      effectiveUnitPrice = buyNowProduct.salePrice * (1 - discount / 100);
    } else {
      effectiveUnitPrice = buyNowProduct.regularPrice * (1 - discount / 100);
    }
  } else {
    // If no active discount, use salePrice if available; otherwise, use regularPrice.
    effectiveUnitPrice = buyNowProduct.salePrice || buyNowProduct.regularPrice || 0;
  }

  return effectiveUnitPrice * quantity;
};







export const getBanners = async () => {
  try {
    return await getRequest('/public/banners');
  } catch (error) {
    throw error;
  }
}

export const fetchTopSellingProducts = async () => {
  try {
    return await getRequest('/public/products/top-selling');
  } catch (error) {
    throw error;
  }
}

export const fetchBelow1000 = async () => {
  try {
    return await getRequest('/public/products/999');
  } catch (error) {
    throw error;
  }
}

export const getProductsByListOfIds = async (ids) => {
  try {
    return await postRequest(`/public/products/list`, ids);
  } catch (error) {
    throw error;
  }
}


export const fetchHotdeals = async (page = 0, size = 18) => {
  try {
    const response = await getRequest(`/public/products/hot-deals?page=${page}&size=${size}`);
    return response; // Response will contain paginated data
  } catch (error) {
    throw error;
  }
}

// export const fetchFeaturedProducts = async (page = 0, size = 18) => {
//   try {
//     const response = await getRequest(`/public/products/featured?page=${page}&size=${size}`);
//     return response; // Response will contain paginated data
//   } catch (error) {
//     throw error;
//   }
// };

// export const fetchSaleProducts = async (page = 0, size = 18) => {
//   try {
//     const response = await getRequest(`/public/products/sale?page=${page}&size=${size}`);
//     return response; // Response will contain paginated data
//   } catch (error) {
//     throw error;
//   }
// };


export const forgotPassword = async (email) => {
  try {
    return await postRequest('/public/api/auth/forgot-password', { email });
  } catch (error) {
    throw error;
  }
}


export const verifyOtp = async (email, otp) => {
  try {
    return await postRequest('/public/api/auth/verify-otp', { email, otp });
  } catch (error) {
    throw error;
  }
};


export const resetPassword = async (token, newPassword) => {
  try {
    return await putRequest('/public/api/auth/customer/reset-password', { token, newPassword });
  } catch (error) {
    throw error;
  }
};

export const submitOrderComplaint = async (complaint) => {
  try {
    return await postRequest('/public/complaint', complaint);
  } catch (error) {
    throw error;
  }
};

export const getCollectionByType = async (type,page=0,size=20) => {
  try {
    return await getRequest(`/public/collections/type/${type}?page=${page}&size=${size}`);
  } catch (error) {
    throw error;
  }
};

export const getAllCollections = async () => {
  try {
    return await getRequest('/public/collections');
  } catch (error) {
    throw error;
  }
};

export const getCollectionById = async (id,page=0,size=20) => {
  try {
    return await getRequest(`/public/collections/id/${id}?page=${page}&size=${size}`);
  } catch (error) {
    throw error;
  }
};


export const sendContactUsEmail = async (data) => {
  try {
    console.log("data",data);
    return await postRequest('/public/customer/contact', data);
  } catch (error) {
    throw error;
  }
}

export const trackOrder = async (orderId) => {
  try {
    return await getRequest(`/public/ordertracking/${orderId}`);
  } catch (error) {
    throw error;
  }
};

export const generateOTPRegister = async (email) => {
  try {
    console.log("email",email);
    return await postRequest('/auth/customer/generate-otp', { email });
  } catch (error) {
    throw error;
  }
};